// @flow
import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import type { PageChildType } from 'types/PageNode';
import type { RouterProps } from 'types/Router';

type Props = RouterProps & {
  childrenList: PageChildType[]
};

function PrevNextPages({ childrenList, match }: Props) {
  const childrenListLength = childrenList.length;
  const splitedPathname = window.location.pathname.split(['/']);
  const currentSlug = splitedPathname[splitedPathname.length - 1];
  const currentPageIndex = childrenList.findIndex(child => child.object_slug === currentSlug);

  let prevChildIndex = currentPageIndex - 1;
  let nextChildIndex = currentPageIndex + 1;
  if (prevChildIndex < 0) {
    prevChildIndex = childrenListLength - 1;
  }
  if (nextChildIndex > childrenListLength - 1) {
    nextChildIndex = 0;
  }

  const prevChild = childrenList[prevChildIndex];
  const nextChild = childrenList[nextChildIndex];

  return (
    <div className="prev-next-pages mt-2">
      <Link to={`${match.url}/${prevChild.object_slug}`} className="btn btn--cheer btn--white">
        <i className="icon icon-chevron-left link-icon is-inline" />
        <span>{prevChild.title} </span>
      </Link>
      <Link to={`${match.url}/${nextChild.object_slug}`} className="btn btn--cheer btn--white btn--right">
        <span>{nextChild.title}</span>
        <i className="icon icon-chevron-right link-icon is-inline" />
      </Link>
    </div>
  );
}

export default withRouter(PrevNextPages);
